module.exports = __webpack_public_path__ + "img/ic_suc_3.cb51576f.svg";